'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();
import { cn } from '@qogita/ui/utils/cn'
import { Button, ButtonLoader } from '@qogita/ui/v2/button'
import { Checkbox } from '@qogita/ui/v2/checkbox'
import { InlineNotification } from '@qogita/ui/v2/inline-notification'
import { useSearchParams } from 'next/navigation'
import { useActionState, useState } from 'react'
import { acceptSla } from 'src/core/data-layer/actions/accept-sla'

export function AcceptSla() {
  const [isConfirmed, setIsConfirmed] = useState(false)
  const searchParams = useSearchParams()
  const redirectTo = searchParams?.get('redirectTo') ?? '/dashboard'
  const acceptSlaWithRedirectTo = acceptSla.bind(null, {
    redirectTo,
  })
  const [error, formAction] = useActionState(
    () => acceptSlaWithRedirectTo(),
    null,
  )

  return (
    <form action={formAction} className="flex flex-col gap-6">
      <InlineNotification
        theme="info"
        emphasis="low"
        icon={null}
        message={
          <label className="flex w-full items-start gap-2">
            <Checkbox
              className={cn('mt-1 cursor-pointer')}
              checked={isConfirmed}
              onCheckedChange={() => {
                setIsConfirmed((value) => !value)
              }}
              role="checkbox"
            />
            <span className="text-base">
              I have read, understood, and agree to the Terms and Conditions.
            </span>
          </label>
        }
      />
      {error?.errors.root ? (
        <InlineNotification
          theme="error"
          emphasis="low"
          icon={null}
          message={error.errors.root.message}
        />
      ) : null}
      <Button
        className="md:self-end"
        disabled={!isConfirmed}
        type="submit"
        rumActionName="Confirm Terms and Conditions"
      >
        <ButtonLoader>Confirm</ButtonLoader>
      </Button>
    </form>
  )
}
